import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { IToast } from '../../store/misc/interfaces'
import { Toast } from 'react-bootstrap'
import { removeToast } from '../../store/misc/misc'
import { useMediaQuery } from 'react-responsive'
import { isSmallMobileQuery } from '../../utils'

const escapeHtml = (unsafe: string): string =>
  unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

const injectHTML = (safe: string): string =>
  safe
    .replace('\n', '<br/>')
    .replace('/s', '</strong>')
    .replace('s/', '<strong>')

const ToastContainer = () => {
  const dispatch = useDispatch()
  const { toasts } = useSelector((state: RootState) => state.misc)
  const isSmallMobile = useMediaQuery(isSmallMobileQuery)
  const [clearKey, setClearKey] = useState(0)
  const prevToastLength = useRef(toasts.length)

  // Detect when toasts are cleared programmatically
  useEffect(() => {
    if (prevToastLength.current > 0 && toasts.length === 0) {
      setClearKey(prev => prev + 1) // Force re-render to clear all toasts immediately
    }
    prevToastLength.current = toasts.length
  }, [toasts.length])

  const renderedToasts = toasts.map((toast: IToast, key: number) => {
    const isImportant = ['danger', 'warning'].includes(toast.type)

    return (
      <Toast
        onClose={() => dispatch(removeToast(key))}
        key={`${clearKey}-${key}-${toast.body}`}
        delay={toast.duration || (isImportant ? 6000 : 4000)}
        autohide={toast.autohide ?? true}
        className={"toast-custom"}
      >
        <Toast.Header
          className={
            `bg-${toast.type} ` +
            (toast.type === 'info'
              ? 'toast-black-close '
              : 'toast-white-close ') +
            `toast-header-${toast.type}`
          }
        >
          <strong className='mr-auto'>{toast.title}</strong>
        </Toast.Header>
        <Toast.Body
          dangerouslySetInnerHTML={{
            __html: injectHTML(escapeHtml(toast.body)),
          }}
        />
      </Toast>
    )
  })
  return (
    <div
      className={
        `${!isSmallMobile && 'w-100 '}` +
        'd-flex justify-content-end toasts-container'
      }
    >
      {renderedToasts}
    </div>
  )
}

export default ToastContainer
